var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuPusher(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "menu-pusher-a",
    d: "M9.58503823,10.8097208 L21.8850342,10.8097208 C21.9977759,10.8097208 22.0899828,10.7226974 22.0899828,10.616455 L22.0899828,9.26415997 C22.0899828,9.15793637 21.9977759,9.07102616 21.8850342,9.07102616 L9.58503823,9.07102616 C9.47231652,9.07102616 9.37992955,9.15791751 9.37992955,9.26415997 L9.37992955,10.616455 C9.37992955,10.7227163 9.4722965,10.8097208 9.58503823,10.8097208 Z M9.37992955,15.73584 C9.37992955,15.8420825 9.4722965,15.9289738 9.58503823,15.9289738 L21.8850342,15.9289738 C21.9977759,15.9289738 22.0899828,15.8420825 22.0899828,15.73584 L22.0899828,14.383545 C22.0899828,14.2773026 21.9977759,14.1904489 21.8850342,14.1904489 L9.58503823,14.1904489 C9.47231652,14.1904489 9.37992955,14.2773026 9.37992955,14.383545 L9.37992955,15.73584 Z M22.2950514,4 L2.20492855,4 C2.09220684,4 2,4.08691021 2,4.19313381 L2,5.54542883 C2,5.65167128 2.09220684,5.7386758 2.20492855,5.7386758 L22.2950514,5.7386758 C22.4077932,5.7386758 22.5,5.65167128 22.5,5.54542883 L22.5,4.19313381 C22.5,4.08692907 22.4077932,4 22.2950514,4 Z M22.2950514,19.2614751 L2.20492855,19.2614751 C2.09220684,19.2614751 2,19.3483476 2,19.4545712 L2,20.8068662 C2,20.9131086 2.09220684,21 2.20492855,21 L22.2950514,21 C22.4077932,21 22.5,20.9131086 22.5,20.8068662 L22.5,19.4545712 C22.5,19.3483664 22.4077932,19.2614751 22.2950514,19.2614751 Z M2.77898467,15.6416684 L6.78412791,12.6690298 C6.89953156,12.584496 6.89953156,12.4203512 6.78412791,12.3333466 L2.77898467,9.35838814 C2.63035693,9.24731734 2.4099972,9.346355 2.4099972,9.52498491 L2.4099972,15.4725443 C2.4099972,15.6513063 2.62787513,15.7527204 2.77898467,15.6416684 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-2 -4)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "menu-pusher-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#menu-pusher-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    fillRule: "nonzero",
    xlinkHref: "#menu-pusher-a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#B2B2B2",
    mask: "url(#menu-pusher-b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPusher);
export default __webpack_public_path__ + "static/media/menu-pusher.570a0a38.svg";
export { ForwardRef as ReactComponent };